export function shouldShow(state, ...values) {
  return values.includes(state)
}

export function shouldShowConfirmed(state, confirmation_status) {
  return state === 'SCHEDULED' && confirmation_status === 'UNCONFIRMED'
}
